var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLineDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.168 21.303"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#171a22",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.061 14.03l6.523 6.523 6.523-6.523",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.584.001v19.553"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4xNjgiIGhlaWdodD0iMjEuMzAzIiB2aWV3Qm94PSIwIDAgMTUuMTY4IDIxLjMwMyI+PGRlZnM+PHN0eWxlPi5hLC5ie2ZpbGw6bm9uZTtzdHJva2U6IzE3MWEyMjtzdHJva2Utd2lkdGg6MS41cHg7fS5he3N0cm9rZS1saW5lY2FwOnNxdWFyZTtzdHJva2UtbGluZWpvaW46cm91bmQ7fTwvc3R5bGU+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00OTQuMDUgLTQ4OS43NikiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMjU2IDAuMjYpIj48cGF0aCBjbGFzcz0iYSIgZD0iTTQ5Ni44ODQsNTEwLjA0NWw2LjUyMyw2LjUyMyw2LjUyMy02LjUyMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuMDI5IC02LjUxNSkiLz48cGF0aCBjbGFzcz0iYiIgZD0iTTUwMC4zNzgsNDg1Ljk4MXYxOS41NTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMy41MikiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgArrowLineDown as ReactComponent };